var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85 0.383057L0.5 2.73306L7.81667 10.0497L11.5 17.8164L9.25 21.8997C8.98333 22.3664 8.83333 22.9164 8.83333 23.4997C8.83333 25.3331 10.3333 26.8331 12.1667 26.8331H24.6L26.9 29.1331C26.3277 29.5433 25.9003 30.1246 25.6792 30.7931C25.4581 31.4617 25.4548 32.1831 25.6697 32.8537C25.8846 33.5243 26.3066 34.1095 26.8751 34.525C27.4435 34.9406 28.1292 35.1651 28.8333 35.1664C29.95 35.1664 30.9333 34.6164 31.5333 33.7664L36.2667 38.4997L38.6167 36.1497L2.85 0.383057ZM12.1667 23.4997L14 20.1664H17.9333L21.2667 23.4997H12.1667ZM33.8333 5.16639H12.3667L15.7 8.49972H31.0167L26.4167 16.8331H24.0167L27.25 20.0664C28.15 19.8331 28.9 19.2497 29.3333 18.4497L35.3 7.63306C35.9167 6.53306 35.1 5.16639 33.8333 5.16639ZM12.1667 28.4997C10.3333 28.4997 8.85 29.9997 8.85 31.8331C8.85 33.6664 10.3333 35.1664 12.1667 35.1664C14 35.1664 15.5 33.6664 15.5 31.8331C15.5 29.9997 14 28.4997 12.1667 28.4997Z",
    fill: "#BDBDBD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/cartEmpty.9a9a223de8c0f0364dd27be3ed12d4fd.svg";
export { ForwardRef as ReactComponent };